import { statusClass, bucketClass } from "@/lib/format";

// Item 4 (previous-trades label pass) — the backend/internal status value
// stays exactly as it is everywhere (inquiry.status keeps storing "WON",
// business logic is untouched); only the text rendered to the user changes.
// StatusPill is the single rendering choke-point every dashboard (Sales,
// Operations, Finance, Management) already routes status text through, so
// one lookup here relabels it everywhere with no other file needing to
// change. Anything not in this map renders exactly as before.
const DISPLAY_LABELS = { WON: "Completed" };

export function displayLabel(status) {
  const key = String(status || "").trim().toUpperCase();
  return DISPLAY_LABELS[key] || status;
}

export function StatusPill({ status, bucket, className = "", ...rest }) {
  const cls = bucket ? bucketClass(bucket) : statusClass(status);
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-semibold border whitespace-nowrap ${cls} ${className}`} {...rest}>
      {displayLabel(status)}
    </span>
  );
}

export function SectionLabel({ children, className = "" }) {
  return (
    <div className={`text-[11px] font-semibold uppercase tracking-wider text-slate-400 ${className}`}>
      {children}
    </div>
  );
}
